import React from 'react';
import { Link } from 'react-router-dom';

const AiSmartClassroom = () => {
    return (
        <section className="bg-white text-gray-900 py-16 px-6 sm:px-12 lg:px-24">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10">
                <div className="flex-1 flex items-stretch">
                    <img
                        src="/images/ai-gen-image.png" 
                        alt="AI Smart Classroom"
                        className="w-full h-full object-cover max-h-[600px] rounded-lg"
                        style={{ minHeight: '100%' }}
                    />
                </div>
                <div className="flex-1">
                    <span className="text-sm uppercase font-bold text-[#0097b2]  tracking-widest mb-2 block">
                        🔥 Ghazipur’s First AI-Enabled Coaching
                    </span>

                    <h2 className="md:text-4xl text-3xl font-semibold leading-tight ">
                        Experience the Future of Learning with <span className="text-[#0097b2] ">AI-Powered Smart Classrooms</span>
                    </h2>

                    <p className="md:text-lg text-base text-gray-700 mb-6 mt-2">
                        At <strong>SSS Achievers</strong>, we bring innovation to education with our exclusive AI-integrated system.
                        From real-time concept generation on smart whiteboards to auto-generated notes and personalized learning feedback-
                        your preparation just got smarter and faster.
                    </p>

                    <ul className="space-y-3 mb-8">
                        <li className="flex items-start gap-2">
                            <span className="text-blue-600 font-bold">✓</span>
                            <span>AI Generative Whiteboard for Instant Concept Clarity</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-600 font-bold">✓</span>
                            <span>Auto-Generated Smart Notes After Every Session</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-600 font-bold">✓</span>
                            <span>Real-Time Performance Feedback via AI Algorithms</span>
                        </li>
                    </ul>

                    <div className="flex flex-wrap gap-4">
                        <Link
                            to="/courses"

                            className="bg-[#f7bb0a] hover:bg-[#e5ad09] text-black px-6 py-3  font-semibold transition rounded"
                        >
                            🚀 Join the Smart Revolution
                        </Link>
                        <Link
                            href="tel:+919918519991"
                            className="border border-[#0097b2] text-[#0097b2] px-6 py-3 hover:bg-[#0097b2] hover:text-white transition rounded"
                        >
                            📞 +91 99185 19991
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AiSmartClassroom;
